import Layout from "../components/Layout";
import Employees  from "../components/_Employees";

const EmployeesPage = (props: any) => {
    return (
        <Layout>
            <Employees />
        </Layout>
    )
}

export default EmployeesPage